/* eslint-disable import/prefer-default-export */
const parseNumberedLabel = (value) =>
  value && value !== 'NA' ? `# ${value}` : 'NA';

export default parseNumberedLabel;
